/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from 'react';
import { Button, Col, Container, Form, Row, Toast, ToastContainer } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { isEmpty, filter } from 'lodash';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { useHistory, useParams } from 'react-router-dom';
import {
  stringRequiredTrim,
  saleChannelValidation,
  maxMsg,
  stringNotRequiredUrlMatch,
  katakanaFullSizeValidation,
  katakanaFullSizeNotReqValidation,
  maximumValueValidation,
  ENGLISH_CHAR_ONLY,
  bankAccountNumberIsRequireValidation,
  bankAccountNumberNotRequireValidation,
} from 'Utils/Validation';

import FormGroupInput from 'Components/Common/Form/FormGroupInput';
import BoxForm from 'Components/Common/Form/BoxForm';
import ModalComponent from 'Components/Common/Modal';
import { RecordCompanyApi, IRecordCompanyOptions } from 'Datasource/RecordCompany';
import useMessage from 'Hooks/useMessage';
import SpinnerComponent from 'Components/Common/SpinnerComponent';
import {
  handleEnteringPhoneNumber,
  handleEnteringNumber,
  handleEnteringIp,
  handleEnteringDecimal,
} from 'Utils/Numbers';
import 'Components/Page/RecordCompanyList/index.scss';
import MessageError from 'Components/Common/MessageError';
import TableCost from 'Components/Page/RecordCompanyList/TableCost';
import FormInputNumber from 'Components/Common/Form/FormInputNumber';
import { costInformationList, CARDBUYFREE, TAXFEE } from 'Constant/Mockup';
import { MAX_FEE } from 'Constant';
// import { handleSearchSaleChannels } from 'Utils/Search';
import { SaleChannelApi } from 'Datasource/SaleChannelApi';
import CheckBoxs from 'Components/Common/Form/GroupCheckBox/CheckBoxs';
import { FormTypeOptions } from 'Constant/FormType';
import { AccountTypeOption, AccountTypeEcOption } from 'Constant/AccountType';
import FormGroupSelect from 'Components/Common/EC/FormGroupSelect';
import { BankApi } from 'Datasource/Bank';
import CopyPasteIcon from 'Components/Icon/CopyPasteIcon';
import NumberFormat from 'react-number-format';
import FormGroupInputEc from 'Components/Common/EC/FormGroupInput';
import { useQueryParams, StringParam } from 'use-query-params';

import { handleEnglishCharOnly } from 'Utils/TextField';

const LABEL_INPUT = 3;
const COL_INPUT = 9;

const recordSchema = yup
  .object()
  .shape({
    companyName: yup
      .string()
      .nullable()
      .max(255, maxMsg(255))
      .required('入力してください。')
      .trim('入力してください。'),
    companyAgentName: yup
      .string()
      .nullable()
      .max(255, maxMsg(255))
      .required('入力してください。')
      .trim('入力してください。'),
    companyZipCode: yup
      .string()
      .nullable()
      .max(255, maxMsg(255))
      .required('入力してください。')
      .trim('入力してください。'),
    companyFirstAddress: yup
      .string()
      .nullable()
      .max(255, maxMsg(255))
      .required('入力してください。')
      .trim('入力してください。'),
    companySecondAddress: yup.string().nullable().max(255, maxMsg(255)),
    companyPhoneNumber: yup
      .string()
      .nullable()
      .max(255, maxMsg(255))
      .required('入力してください。')
      .trim('入力してください。'),
    bankCode: yup
      .string()
      .nullable()
      .max(255, maxMsg(255))
      .required('入力してください。')
      .trim('入力してください。'),
    bankName: yup.string().nullable().max(255, maxMsg(255)),
    branchCode: yup
      .string()
      .nullable()
      .max(255, maxMsg(255))
      .required('入力してください。')
      .trim('入力してください。'),
    branchName: yup
      .string()
      .nullable()
      .max(255, maxMsg(255))
      .test(
        'codeErr',
        '入力した支店コードが一致する支店名は存在しません。',
        (value) => value !== '入力した支店コードが一致する支店名は存在しません。',
      ),
    bankAccountNumber: bankAccountNumberIsRequireValidation(7)
      .nullable()
      .trim('入力してください。'),
    bankAccountOwner: katakanaFullSizeValidation({}).nullable().trim('入力してください。'),
    companyRegistrationNumber: yup
      .string()
      .matches(ENGLISH_CHAR_ONLY, '半角英数字で入力してください。')
      .max(14, maxMsg(14))
      .nullable(),
    accountName: yup
      .string()
      .nullable()
      .max(255, maxMsg(255))
      .required('入力してください。')
      .trim('入力してください。'),
    sectionName: yup
      .string()
      .nullable()
      .max(255, maxMsg(255))
      .required('入力してください。')
      .trim('入力してください。'),
    accountPhone: yup
      .string()
      .nullable()
      .max(255, maxMsg(255))
      .required('入力してください。')
      .trim('入力してください。'),
    channelIds: saleChannelValidation({}),
    snFee: stringRequiredTrim({}),
    snImportFee: stringRequiredTrim({}),
    companyRecordOptions: yup.array().of(
      yup.object().shape({
        titleType: stringRequiredTrim({}),
        cardBuyFee: stringRequiredTrim({}),
        taxFee: stringRequiredTrim({}),
      }),
    ),
  })
  .required();

const miimEcSchema = yup
  .object()
  .shape({
    companyName: yup
      .string()
      .nullable()
      .max(255, maxMsg(255))
      .required('入力してください。')
      .trim('入力してください。'),
    companyAgentName: yup
      .string()
      .nullable()
      .nullable()
      .max(255, maxMsg(255))
      .required('入力してください。')
      .trim('入力してください。'),
    companyZipCode: yup
      .string()
      .nullable()
      .max(255, maxMsg(255))
      .required('入力してください。')
      .trim('入力してください。'),
    companyFirstAddress: yup
      .string()
      .nullable()
      .max(255, maxMsg(255))
      .required('入力してください。')
      .trim('入力してください。'),
    companySecondAddress: yup.string().nullable(true).max(255, maxMsg(255)),
    companyPhoneNumber: yup
      .string()
      .nullable()
      .max(255, maxMsg(255))
      .required('入力してください。')
      .trim('入力してください。'),
    bankCode: yup
      .string()
      .nullable()
      .max(255, maxMsg(255))
      .required('入力してください。')
      .trim('入力してください。'),
    branchCode: yup
      .string()
      .nullable()
      .max(255, maxMsg(255))
      .required('入力してください。')
      .trim('入力してください。'),
    branchName: yup
      .string()
      .nullable()
      .max(255, maxMsg(255))
      .test(
        'codeErr',
        '入力した支店コードが一致する支店名は存在しません。',
        (value) => value !== '入力した支店コードが一致する支店名は存在しません。',
      ),
    saleChannelDetailBankCode: yup.string().nullable(true).max(255, maxMsg(255)),
    saleChannelDetailBranchCode: yup.string().nullable(true).max(255, maxMsg(255)),
    saleChannelDetailBranchName: yup
      .string()
      .nullable()
      .max(255, maxMsg(255))
      .test(
        'codeErr',
        '入力した支店コードが一致する支店名は存在しません。',
        (value) => value !== '入力した支店コードが一致する支店名は存在しません。',
      ),
    bankAccountNumber: bankAccountNumberIsRequireValidation(7)
      .nullable()
      .trim('入力してください。'),
    bankAccountOwner: katakanaFullSizeValidation({}).nullable(true).trim('入力してください。'),
    companyRegistrationNumber: yup
      .string()
      .matches(ENGLISH_CHAR_ONLY, '半角英数字で入力してください。')
      .max(14, maxMsg(14))
      .nullable(),
    accountName: yup
      .string()
      .nullable()
      .max(255, maxMsg(255))
      .required('入力してください。')
      .trim('入力してください。'),
    sectionName: yup
      .string()
      .nullable()
      .max(255, maxMsg(255))
      .required('入力してください。')
      .trim('入力してください。'),
    accountPhone: yup
      .string()
      .nullable()
      .max(255, maxMsg(255))
      .required('入力してください。')
      .trim('入力してください。'),
    saleChannelDetailSiteName: yup.string().nullable().max(255, maxMsg(255)),
    saleChannelDetailSiteUrl: stringNotRequiredUrlMatch()
      .test('lastSlashForbided', 'URLの末尾に「/」をつけないでください。', (value: any) =>
        value?.slice(-1) !== '/' ? true : false,
      )
      .nullable(),
    saleChannelDetailChannelName: yup
      .string()
      .nullable()
      .max(255, maxMsg(255))
      .required('入力してください。')
      .trim('入力してください。'),
    saleChannelDetailIpAddress: yup.string().nullable(true).max(255, maxMsg(255)),
    saleChannelDetailPlatformUsageFee: yup
      .string()
      .when('formType', {
        is: 0,
        then: maximumValueValidation(),
      })
      .nullable()
      .max(255, maxMsg(255)),
    saleChannelDetailBankAccountType: yup.number().max(255, maxMsg(255)).nullable(true),
    saleChannelDetailBankAccountNumber: bankAccountNumberNotRequireValidation(7).nullable(true),
    saleChannelDetailBankAccountOwner: katakanaFullSizeNotReqValidation().nullable(true),
  })
  .required();

interface ListSaleChannel {
  id: number;
  companyName: string;
  channelName: string;
  roleCd?: string;
  siteName?: string;
  siteUrl?: string;
}

interface ContactInfomation {
  companyId: number;
  accountId: number;
  accountName: string;
  accountEmail: string;
  accountPhone: string;
  sectionName: string;
  roleName: string;
  artistList: Array<string>;
}

export default function RecordCompanyDetails(): JSX.Element {
  const history = useHistory();

  const [showModal, setShowModal] = useState(false);
  const scollToRef = useRef<any>();

  const [isLoading, setIsloading] = useState<boolean>(false);
  const [formTypeValue, setFormTypeValue] = useState<number>(10);
  const [paymentMethodChecked, setPaymentMethodChecked] = useState<boolean>(false);
  const [listSaleChannel, setListSaleChannel] = useState<ListSaleChannel[]>([]);
  const [contactList, setContactList] = useState<ContactInfomation[]>([]);
  const [accessKey, setAccessKey] = useState<string>('');
  const [secretKey, setSecretKey] = useState<string>('');
  const [copyAccessKey, setCopyAccessKey] = useState<string>('');
  const [copySecretKey, setCopySecretKey] = useState<string>('');
  const [saleChannelStatus, setSaleChannelStatus] = useState<number>(0);
  const [showToast, setShowToast] = useState<boolean>(false);
  const { id }: { id: string } = useParams();

  //! please use useQueryParams to get query from url
  const [query] = useQueryParams({ role: StringParam, status: StringParam });
  const role = query?.role;
  const status = query?.status;

  const handleFetchSales = async () => {
    try {
      setIsloading(true);
      const {
        data: { data },
      } = await SaleChannelApi.getSaleChannelsEc(1, 100);

      setListSaleChannel(data?.items || []);
    } catch (error) {
      openMessageError(error);
    } finally {
      setIsloading(false);
    }
  };

  const handleFetchSalesData = async () => {
    try {
      setIsloading(true);
      const {
        data: { data },
      } = await SaleChannelApi.getSaleChannelEcDetail(id);
      setContactList(data.accounts);
      if (data.companyType == 'EC_COMPANY' || data.companyType == 'SALE_CHANNEL_COMPANY') {
        if (data.companyType == 'EC_COMPANY') {
          setValue('formType', 0);
        }
        if (data.companyType == 'SALE_CHANNEL_COMPANY') {
          setValue('formType', 1);
        }
        const objectKeyArr = Object.keys(data);
        objectKeyArr.map((keyName) => {
          // if (keyName == 'saleChannelDetailBankAccountType') {
          //   setValue(keyName, data[keyName] ?? 0);
          // } else {
          setValue(keyName, data[keyName]);
          // }
        });
        data.saleChannelDetailCreditCardPayment == 0
          ? setPaymentMethodChecked(false)
          : setPaymentMethodChecked(true);
        setAccessKey(data.accessKey);
        setSecretKey(data.privateKey);
        setCopyAccessKey(data.saleChannelDetailAccessKey);
        setCopySecretKey(data.saleChannelDetailPrivateKey);
        setSaleChannelStatus(data.saleChannelDetailStatus);
      }
    } catch (error) {
      openMessageError(error);
    } finally {
      setIsloading(false);
    }
  };

  const handleFetchRecordData = async () => {
    try {
      setIsloading(true);
      const {
        data: { data },
      } = await RecordCompanyApi.getRecordCompanyDetail(id);
      setContactList(data.accounts);
      setValue('formType', 10);
      const objectKeyArr = Object.keys(data.companyInfo);
      objectKeyArr.map((keyName) => {
        setValue(keyName, data.companyInfo[keyName]);
      });
      const tempChannel = [...watch('channelIds')];
      const recordCompanyChannels = data.recordCompanyConfig.recordCompanyChannels;
      recordCompanyChannels.map((item: any) => {
        tempChannel.push(item.id);
      });
      setValue('channelIds', tempChannel);
      const recordCompanyOptions = data.recordCompanyConfig.recordCompanyOptions;
      setValue('companyRecordOptions', recordCompanyOptions);
      setValue('snFee', data.companyInfo.companySnFee);
      setValue('snImportFee', data.companyInfo.companySnImportFee);
    } catch (error) {
      openMessageError(error);
    } finally {
      setIsloading(false);
    }
  };

  const { openMessageError } = useMessage();

  const callbackRef = useRef<{ handleUpdateDeepTable: (newRow: any) => void }>(null);

  useEffect(() => {
    handleFetchSales();
    if (role == 'RECORD_COMPANY') {
      handleFetchRecordData();
    } else {
      handleFetchSalesData();
    }
  }, [role]);

  const handleCheckChannel = (value: string) => {
    let tempChannel = [...watch('channelIds')];
    const valueNumber = Number(value);
    if (tempChannel.indexOf(valueNumber) === -1) {
      tempChannel.push(valueNumber);
    } else {
      tempChannel = filter(tempChannel, (item) => item !== valueNumber);
    }

    setValue('channelIds', tempChannel);
  };

  const handleCheckPaymentUsed = () => {
    setPaymentMethodChecked(!paymentMethodChecked);
  };

  const handleChangeTable = (childData: any) => {
    setValue('companyRecordOptions', childData);
  };

  const handleAddRowTable = () => {
    const dataTable = [...watch('companyRecordOptions')];
    const lastRow = dataTable.length > 5 ? dataTable[dataTable.length - 1] : dataTable[4];
    const newRow: IRecordCompanyOptions = {
      titleType: '',
      maxSongCount: incrementValue(lastRow.maxSongCount),
      minPrice: incrementValue(lastRow.minPrice),
      maxVariationStorage: incrementValue(lastRow.maxVariationStorage),
      limitTokutenStorage: incrementValue(lastRow.limitTokutenStorage),
      cardBuyFee: CARDBUYFREE,
      taxFee: TAXFEE,
      deletable: true,
    };
    const tempData = [...dataTable, newRow];
    setValue('companyRecordOptions', tempData);
    callbackRef && callbackRef?.current?.handleUpdateDeepTable(tempData);
  };

  const {
    register,
    handleSubmit,
    setValue,
    watch,
    reset,
    clearErrors,
    formState: { errors },
  } = useForm({
    mode: 'onSubmit',
    resolver: yupResolver(formTypeValue === 10 ? recordSchema : miimEcSchema),
  });

  useEffect(() => {
    if (watch('bankName') == bankNameError) {
      clearErrors('bankCode');
    }
    if (watch('branchName') == branchNameError) {
      clearErrors('branchCode');
    }
    if (watch('saleChannelDetailBankName') == bankNameError) {
      clearErrors('saleChannelDetailBankCode');
    }
    if (watch('saleChannelDetailBranchName') == bankNameError) {
      clearErrors('saleChannelDetailBranchCode');
    }
  }, [
    watch('bankName'),
    watch('saleChannelDetailBankName'),
    watch('branchName'),
    watch('saleChannelDetailBranchName'),
  ]);

  const onSubmit = handleSubmit(() => {
    setShowModal(true);
  });

  const onSubmitModal = async () => {
    setIsloading(true);

    if (isEmpty(errors) && formTypeValue == 10) {
      const recordOptions = [...watch('companyRecordOptions')];
      recordOptions.forEach((item) => {
        item.deletable = false;
        item.maxSongCount = item.maxSongCount.toString();
        item.minPrice = item.minPrice.toString();
        item.maxVariationStorage = item.maxVariationStorage.toString();
        item.limitTokutenStorage = item.limitTokutenStorage.toString();
        item.cardBuyFee = item.cardBuyFee.toString();
      });
      const param = {
        companyName: watch('companyName').trim(),
        agentName: watch('companyAgentName'),
        zipCode: watch('companyZipCode'),
        firstAddress: watch('companyFirstAddress'),
        secondAddress: watch('companySecondAddress'),
        phoneNumber: watch('companyPhoneNumber'),
        bankCode: watch('bankCode'),
        bankName: watch('bankName'),
        branchCode: watch('branchCode'),
        branchName: watch('branchName'),
        bankAccountType: watch('bankAccountType') ? watch('bankAccountType') : 0,
        bankAccountNumber: watch('bankAccountNumber'),
        bankAccountOwner: watch('bankAccountOwner'),
        registrationNumber: watch('companyRegistrationNumber'),
        masterName: watch('accountName'),
        sectionName: watch('sectionName'),
        masterPhone: watch('accountPhone'),
        masterEmail: watch('accountEmail').trim(),
        channelIds: watch('channelIds'),
        snFee: watch('snFee'),
        snImportFee: watch('snImportFee'),
        companyRecordOptions: recordOptions,
      };
      try {
        setShowModal(false);
        await RecordCompanyApi.updateRecordCompany(id, param);
        // if (onChangeTab) onChangeTab();
        history.push('/record-company-list?status=レコード会社リスト');
      } catch (error) {
        openMessageError(error);
      } finally {
        setIsloading(false);
      }
    } else if (isEmpty(errors) && formTypeValue != 10) {
      const param = {
        company: {
          name: watch('companyName').trim(),
          agentName: watch('companyAgentName'),
          zipCode: watch('companyZipCode'),
          firstAddress: watch('companyFirstAddress'),
          secondAddress: watch('companySecondAddress'),
          phoneNumber: watch('companyPhoneNumber'),
          bankCode: watch('bankCode'),
          bankName: watch('bankName'),
          branchCode: watch('branchCode'),
          branchName: watch('branchName'),
          bankAccountType: watch('bankAccountType') ? watch('bankAccountType') : 0,
          bankAccountNumber: watch('bankAccountNumber'),
          bankAccountOwner: watch('bankAccountOwner'),
          registrationNumber: watch('companyRegistrationNumber'),
          sectionName: watch('sectionName'),
        },
        account: {
          name: watch('accountName'),
          phone: watch('accountPhone'),
          email: watch('accountEmail').trim(),
        },
        saleChannel: {
          siteName: watch('saleChannelDetailSiteName'),
          siteUrl: watch('saleChannelDetailSiteUrl'),
          channelName: watch('saleChannelDetailChannelName'),
          status: saleChannelStatus,
          ipAddress: watch('saleChannelDetailIpAddress'),
          platformUsageFee: watch('saleChannelDetailPlatformUsageFee')
            ? watch('saleChannelDetailPlatformUsageFee')
            : 0,
          creditCardPayment: paymentMethodChecked,
          bankCode: watch('saleChannelDetailBankCode'),
          bankName: watch('saleChannelDetailBankName'),
          branchCode: watch('saleChannelDetailBranchCode'),
          branchName: watch('saleChannelDetailBranchName'),
          bankAccountType: watch('saleChannelDetailBankAccountType')
            ? watch('saleChannelDetailBankAccountType')
            : 0,
          bankAccountNumber: watch('saleChannelDetailBankAccountNumber'),
          bankAccountOwner: watch('saleChannelDetailBankAccountOwner'),
        },
      };
      try {
        setShowModal(false);
        await SaleChannelApi.updateSaleChannelEc(id, param);
        // if (onChangeTab) onChangeTab();
        history.push('/record-company-list?status=レコード会社リスト');
      } catch (error) {
        openMessageError(error);
      } finally {
        setIsloading(false);
      }
    } else {
      throw new Error(`Unknown error: ${JSON.stringify(errors)}`);
    }
  };

  const incrementValue = (value: string) => {
    return String(+value + 1);
  };

  const errorTable = () => {
    let err = '';
    if (errors.companyRecordOptions) {
      errors.companyRecordOptions.forEach((item: any) => {
        Object.values(item).forEach((el: any) => {
          err = el.message as string;
        });
      });
    }
    return err;
  };

  useEffect(() => {
    reset({
      snFee: '1.0',
      snImportFee: '1.0',
      companyRecordOptions: costInformationList,
      channelIds: [],
    });
    callbackRef && callbackRef?.current?.handleUpdateDeepTable(costInformationList);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setFormTypeValue(watch('formType'));
  }, [watch('formType')]);

  const bankNameError = '入力した銀行コードが一致する銀行名は存在しません。';
  const branchNameError = '入力した支店コードが一致する支店名は存在しません。';

  const getBankInfo1 = async (bankCode: string) => {
    const response = await BankApi.getBankInfo(bankCode);
    if (response.data.data[0]) {
      setValue('bankName', response.data.data[0].name);
    } else {
      setValue('bankName', bankNameError);
    }
  };

  const getBankInfo2 = async (bankCode: string) => {
    const response = await BankApi.getBankInfo(bankCode);
    if (response.data.data[0]) {
      setValue('saleChannelDetailBankName', response.data.data[0].name);
    } else {
      setValue('saleChannelDetailBankName', bankNameError);
    }
  };

  const getBankBranchInfo1 = async (bankCode: string, branchCode: string) => {
    const response = await BankApi.getBankBranchInfo(bankCode, branchCode);
    if (response.data.data[0]) {
      setValue('branchName', response.data.data[0].name);
    } else {
      setValue('branchName', branchNameError);
    }
  };

  const getBankBranchInfo2 = async (bankCode: string, branchCode: string) => {
    const response = await BankApi.getBankBranchInfo(bankCode, branchCode);
    if (response.data.data[0]) {
      setValue('saleChannelDetailBranchName', response.data.data[0].name);
    } else {
      setValue('saleChannelDetailBranchName', branchNameError);
    }
  };

  const copyTextToClipboard = async (text: string) => {
    if ('clipboard' in navigator) {
      return await navigator.clipboard.writeText(text);
    }
  };

  const handleCopyClick = (copyText: string) => {
    copyTextToClipboard(copyText)
      .then(() => {
        setShowToast(true);
      })
      .catch((err: Error) => console.log(err));
  };

  const handleLoginProxy = async (companyId: number, accountId: number) => {
    setIsloading(true);
    const params = {
      userId: accountId,
      companyId: companyId,
    };
    try {
      const res = await RecordCompanyApi.onLoginProxy(params);
      const { accessCode } = res?.data?.data;
      window.open(`${process.env.REACT_APP_RECORD_COMPANY}code/${accessCode}`);
    } catch (error) {
      openMessageError(error);
    } finally {
      setIsloading(false);
    }
  };

  if (status ?? false) {
    scollToRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  return (
    <Container className="py-4">
      <SpinnerComponent isLoading={isLoading} />
      <ModalComponent
        title="登録確認"
        show={showModal}
        onCloseModal={() => setShowModal(false)}
        classNameContent="d-flex align-items-center content-body-modal justify-content-center"
        variantButtonSubmit="primary"
        submitIdForm="curatorManagement"
        onSubmitModal={onSubmitModal}
      >
        <div>入力した内容で登録します。よろしいですか。</div>
      </ModalComponent>
      <Row>
        <Col className="m-auto" md="12">
          <ToastContainer className="ml-105px mb-90px" position="bottom-center">
            <Toast
              onClose={() => setShowToast(false)}
              show={showToast}
              delay={3000}
              autohide
              className="d-inline-block rounded-pill w-auto m-1"
              bg="dark"
            >
              <Toast.Body className="text-white">クリップボードにコピーしました。</Toast.Body>
            </Toast>
          </ToastContainer>
          <Form onSubmit={onSubmit} id="register-artist">
            <BoxForm title="基本設定">
              <>
                <CheckBoxs
                  id="form-type"
                  name="form-type"
                  labelMd={LABEL_INPUT}
                  colMd={COL_INPUT}
                  checkboxClass="flex-nowrap"
                  classOption="mr-80px"
                  labelForm="契約種別*"
                  disabled={true}
                  value={watch('formType')}
                  options={FormTypeOptions}
                  onChange={({ value }) => {
                    setValue('formType', value);
                    setFormTypeValue(watch('formType'));
                  }}
                  classForm="mb-3"
                />

                <FormGroupInput
                  value={watch('companyName')}
                  onChange={(value) => setValue('companyName', value ?? '')}
                  labelMd={LABEL_INPUT}
                  colMd={COL_INPUT}
                  label="法人名*"
                  errorMessage={errors.companyName?.message}
                  register={{ ...register('companyName') }}
                />

                <FormGroupInput
                  value={watch('companyAgentName')}
                  onChange={(value) => setValue('companyAgentName', value ?? '')}
                  labelMd={LABEL_INPUT}
                  colMd={COL_INPUT}
                  label="代表者名*"
                  errorMessage={errors.companyAgentName?.message}
                  register={{ ...register('companyAgentName') }}
                />

                <FormGroupInput
                  value={watch('companyZipCode')}
                  onChange={(value) =>
                    setValue('companyZipCode', handleEnteringNumber(value) ?? '')
                  }
                  labelMd={LABEL_INPUT}
                  colMd={3}
                  label="郵便番号*"
                  maxLength={16}
                  errorMessage={errors.companyZipCode?.message}
                  register={{ ...register('companyZipCode') }}
                />

                <FormGroupInput
                  value={watch('companyFirstAddress')}
                  onChange={(value) => setValue('companyFirstAddress', value ?? '')}
                  labelMd={LABEL_INPUT}
                  colMd={COL_INPUT}
                  label="住所1*"
                  errorMessage={errors.companyFirstAddress?.message}
                  register={{ ...register('companyFirstAddress') }}
                />

                <FormGroupInput
                  value={watch('companySecondAddress')}
                  onChange={(value) => setValue('companySecondAddress', value ?? '')}
                  labelMd={LABEL_INPUT}
                  colMd={COL_INPUT}
                  label="住所2"
                  errorMessage={errors.companySecondAddress?.message}
                  register={{ ...register('companySecondAddress') }}
                />

                <FormGroupInput
                  value={watch('companyPhoneNumber')}
                  onChange={(value) =>
                    setValue('companyPhoneNumber', handleEnteringNumber(value) ?? '')
                  }
                  labelMd={LABEL_INPUT}
                  colMd={3}
                  label="電話番号*"
                  errorMessage={errors.companyPhoneNumber?.message}
                  register={{ ...register('companyPhoneNumber') }}
                />

                <FormGroupInput
                  value={watch('bankCode')}
                  onChange={(value) => {
                    setValue('bankCode', handleEnteringNumber(value) ?? '');
                  }}
                  onBlur={(e: any) => {
                    if (watch('bankCode') == '') {
                      setValue('bankName', '');
                    }
                    getBankInfo1(e.target.value);
                    setValue('branchCode', '');
                    setValue('branchName', '');
                  }}
                  labelMd={LABEL_INPUT}
                  colMd={9}
                  label="銀行コード*"
                  errorMessage={errors.bankCode?.message}
                  messageWrapper="mt-0 ml-6px"
                  maxLength={4}
                  register={{ ...register('bankCode') }}
                  classInput="w-60px"
                  classCol="d-flex align-items-center"
                  hintText={`銀行名 ${watch('bankName') != undefined ? `:` : ''}`}
                  hintTextClass="fs-12 ml-40px"
                  hintTextDes={`${watch('bankName') != undefined ? `${watch('bankName')}` : ''}`}
                  hintTextDesClass={`${
                    watch('bankName') == bankNameError ? 'text-error ml-6px fs-small' : 'ml-6px'
                  }`}
                />

                <FormGroupInput
                  value={watch('branchCode')}
                  onChange={(value) => setValue('branchCode', handleEnteringNumber(value) ?? '')}
                  onBlur={(e: any) => {
                    if (watch('branchCode') == '') {
                      setValue('branchName', '');
                    }
                    if (watch('bankName') != '') {
                      getBankBranchInfo1(watch('bankCode'), e.target.value);
                    }
                  }}
                  labelMd={LABEL_INPUT}
                  colMd={9}
                  label="支店コード*"
                  maxLength={3}
                  errorMessage={errors.branchCode?.message}
                  messageWrapper="mt-0 ml-6px"
                  register={{
                    ...register('branchCode'),
                  }}
                  classInput="w-60px"
                  disabled={
                    watch('bankName') == bankNameError ||
                    watch('bankName') == undefined ||
                    watch('bankName') == ''
                      ? true
                      : false
                  }
                  classCol="d-flex align-items-center"
                  hintText={`支店名 ${watch('branchName') != undefined ? `:` : ''}`}
                  hintTextClass="fs-12 ml-40px"
                  hintTextDes={`${
                    watch('branchName') != undefined ? `${watch('branchName')}` : ''
                  }`}
                  hintTextDesClass={`${
                    watch('branchName') == branchNameError ? 'text-error ml-6px fs-small' : 'ml-6px'
                  }`}
                />

                <CheckBoxs
                  id="bankAccountType"
                  name="bankAccountType"
                  labelMd={LABEL_INPUT}
                  colMd={COL_INPUT}
                  checkboxClass="flex-nowrap"
                  labelForm="口座種別*"
                  value={watch('bankAccountType')}
                  options={AccountTypeOption}
                  onChange={({ value }) => setValue('bankAccountType', value)}
                  classForm="mb-3"
                />

                <FormGroupInput
                  value={watch('bankAccountNumber')}
                  onChange={(value) =>
                    setValue('bankAccountNumber', handleEnteringNumber(value) ?? '')
                  }
                  labelMd={LABEL_INPUT}
                  colMd={3}
                  label="口座番号*"
                  errorMessage={errors.bankAccountNumber?.message}
                  register={{ ...register('bankAccountNumber') }}
                  maxLength={7}
                />

                <FormGroupInput
                  value={watch('bankAccountOwner')}
                  onChange={(value) => setValue('bankAccountOwner', value ?? '')}
                  labelMd={LABEL_INPUT}
                  colMd={COL_INPUT}
                  label="口座名義（カタカナ）*"
                  errorMessage={errors.bankAccountOwner?.message}
                  register={{ ...register('bankAccountOwner') }}
                  hintText="全角カタカナで入力してください（全角カタカナ、全角数字、全角スペース、記号（）．ー／）"
                  hintTextClass="mt-1"
                />

                <FormGroupInputEc
                  value={watch('companyRegistrationNumber')}
                  onChange={(value) =>
                    setValue('companyRegistrationNumber', handleEnglishCharOnly(value) ?? '')
                  }
                  labelMd={LABEL_INPUT}
                  colMd={4}
                  label="登録番号"
                  maxLength={14}
                  errorMessage={errors.companyRegistrationNumber?.message}
                  register={{ ...register('companyRegistrationNumber') }}
                  subLabel="（適格請求書発行事業者登録）"
                  hintText="（14桁）"
                  classCol="d-flex align-items-center"
                  classForm="d-flex align-items-center"
                  hintTextClass=" ml-10px w-fill"
                  leftTextClass="mr-10px"
                  messageWrapper="mb-2px"
                />

                <FormGroupInput
                  value={watch('accountName')}
                  onChange={(value) => setValue('accountName', value ?? '')}
                  labelMd={LABEL_INPUT}
                  colMd={COL_INPUT}
                  label="マスター担当者*"
                  errorMessage={errors.accountName?.message}
                  register={{ ...register('accountName') }}
                />

                <FormGroupInput
                  value={watch('sectionName')}
                  onChange={(value) => setValue('sectionName', value ?? '')}
                  labelMd={LABEL_INPUT}
                  colMd={COL_INPUT}
                  label="所属部署*"
                  errorMessage={errors.sectionName?.message}
                  register={{ ...register('sectionName') }}
                />

                <FormGroupInput
                  value={watch('accountPhone')}
                  onChange={(value) => setValue('accountPhone', handleEnteringPhoneNumber(value))}
                  labelMd={LABEL_INPUT}
                  colMd={COL_INPUT}
                  label="マスター直通電話番号*"
                  errorMessage={errors.accountPhone?.message}
                  register={{ ...register('accountPhone') }}
                  maxLength={13}
                  hintText="※「-」をつけて入力。（例）03-1234-5678 / 080-1234-5678"
                  hintTextClass="mt-1"
                />

                <FormGroupInput
                  value={watch('accountEmail')}
                  onChange={(value) => setValue('accountEmail', value ?? '')}
                  labelMd={LABEL_INPUT}
                  colMd={COL_INPUT}
                  label="メールアドレス*"
                  disabled
                  errorMessage={errors.accountEmail?.message}
                  register={{ ...register('accountEmail') }}
                  hintText="※登録されるメールアドレスはログインに使われます。登録後にメールアドレスを編集できません。"
                  hintTextClass="mt-1"
                />
              </>
            </BoxForm>

            {formTypeValue == 10 && (
              <>
                <div className="mt-4">
                  <BoxForm title="販売チャネル設定">
                    <div className="mb-4px ps-3">
                      <div className="mb-30px">
                        商品を提供する販売チャネルを選択してください。（複数可）
                      </div>
                      <Form.Group className="max-h-410 pr-4px overflow-y-scroll listSale-scrollbar">
                        {listSaleChannel.map((item, index) => (
                          <div className="d-flex list-sale-channel" key={index}>
                            <div>
                              <Form.Check
                                key={index}
                                type="checkbox"
                                id={`sale-channel-${index}`}
                                value={item.id}
                                className="custom-checkbox"
                                checked={watch('channelIds')?.includes(item.id)}
                                onChange={() => handleCheckChannel(item.id.toString())}
                              />
                            </div>
                            <Row className="d-flex w-100">
                              <Col md="6" className="d-flex flex-column justify-content-center">
                                <div className="mb-4px">{item.channelName}</div>
                                <div>
                                  {item.roleCd == 'EC_COMPANY_MASTER' ? 'miim-EC' : '外部EC'}
                                </div>
                              </Col>
                              <Col md="6" className="d-flex flex-column justify-content-center">
                                <div className="mb-4px overflow-hidden">{item.siteName}</div>
                                <a
                                  target="_blank"
                                  rel="noreferrer"
                                  className="overflow-hidden"
                                  href={item.siteUrl}
                                >
                                  {item.siteUrl}
                                </a>
                              </Col>
                            </Row>
                          </div>
                        ))}
                      </Form.Group>

                      <div>
                        <MessageError message={errors.channelIds?.message} />
                      </div>
                    </div>
                  </BoxForm>
                </div>

                <div className="mt-4">
                  <BoxForm title="料金設定">
                    <div className="py-3">
                      <div className="mx-3 border-bottom-gray d-flex justify-content-between align-items-end">
                        <p className="fw-bold mb-1">miimご利用基本料金</p>
                        <Button
                          className="mb-2 btn-action"
                          variant="primary"
                          onClick={handleAddRowTable}
                        >
                          料金テーブル追加
                        </Button>
                      </div>
                      <div className="mt-2 pt-1 pb-5">
                        <TableCost
                          ref={callbackRef}
                          dataTable={watch('companyRecordOptions') || []}
                          onDataChange={handleChangeTable}
                        />
                        <p className="ms-3 fs-11">
                          メガバイトを基準に容量計算を行います。1GBは1024MB換算で登録してください。
                        </p>
                        <div>
                          {errors.companyRecordOptions && (
                            <MessageError classWrapper="ms-4" message={errorTable()} />
                          )}
                        </div>
                      </div>
                      <p className="pb-1 mt-5 underline-100 position-relative fw-bold text-break">
                        シリアルコードオプション料金
                      </p>
                      <div className="mt-2   d-flex">
                        <div className="d-flex flex-column align-items-end">
                          <FormInputNumber
                            name="snFee"
                            labelMd={5}
                            colMd={5}
                            label="1件発行に付き"
                            hintText="円"
                            classCol="d-flex align-items-baseline"
                            classInput="me-2 text-end"
                            classForm="serialForm ms-3"
                            value={watch('snFee')}
                            decimalScale={1}
                            onChange={(value) => setValue('snFee', value ?? '')}
                            pureType
                            maxValue={MAX_FEE}
                          />
                          <MessageError classWrapper="ms-0 me-1" message={errors.snFee?.message} />
                        </div>
                        <div className="d-flex flex-column align-items-end">
                          <FormInputNumber
                            name="snImportFee"
                            labelMd={6}
                            colMd={5}
                            label="1件読み込みに付き"
                            classCol="d-flex align-items-baseline"
                            decimalScale={1}
                            hintText="円"
                            classInput="me-2 text-end"
                            classForm="serialForm ms-5"
                            value={watch('snImportFee')}
                            onChange={(value) => setValue('snImportFee', value ?? '')}
                            pureType
                            maxValue={MAX_FEE}
                          />
                          <MessageError message={errors.snImportFee?.message} />
                        </div>
                      </div>
                    </div>
                  </BoxForm>
                </div>
              </>
            )}

            {/* EC */}
            {(formTypeValue == 0 || formTypeValue == 1) && (
              <>
                <div className="mt-4">
                  <BoxForm title="ECサイト設定">
                    <>
                      <FormGroupInput
                        value={watch('saleChannelDetailSiteName')}
                        onChange={(value) => setValue('saleChannelDetailSiteName', value ?? '')}
                        labelMd={LABEL_INPUT}
                        colMd={COL_INPUT}
                        label="サイト名"
                        errorMessage={errors.saleChannelDetailSiteName?.message}
                        register={{ ...register('saleChannelDetailSiteName') }}
                      />

                      <FormGroupInput
                        value={watch('saleChannelDetailSiteUrl')}
                        onChange={(value) => {
                          setValue('saleChannelDetailSiteUrl', value ?? '');
                        }}
                        // onChange={(value) => setValue('saleChannelDetailSiteUrl', value ?? '')}
                        labelMd={LABEL_INPUT}
                        colMd={COL_INPUT}
                        label="サイトURL"
                        errorMessage={errors.saleChannelDetailSiteUrl?.message}
                        register={{ ...register('saleChannelDetailSiteUrl') }}
                      />

                      <FormGroupInput
                        value={watch('saleChannelDetailChannelName')}
                        onChange={(value) => setValue('saleChannelDetailChannelName', value ?? '')}
                        labelMd={LABEL_INPUT}
                        colMd={COL_INPUT}
                        label="省略チャネル名*"
                        maxLength={10}
                        errorMessage={errors.saleChannelDetailChannelName?.message}
                        register={{ ...register('saleChannelDetailChannelName') }}
                      />

                      <FormGroupSelect
                        colMd="3"
                        rowClass="w-100 mb-3"
                        labelMd="3"
                        label="ステータス"
                        placeholder=""
                        value={
                          saleChannelStatus == 0
                            ? { label: 'システム対応中', value: 0 }
                            : { label: '稼働中', value: 1 }
                        }
                        options={[
                          { label: 'システム対応中', value: 0 },
                          { label: '稼働中', value: 1 },
                        ]}
                        onChange={(e) => setSaleChannelStatus(e.value)}
                      />

                      <FormGroupInput
                        value={watch('saleChannelDetailIpAddress')}
                        onChange={(value) =>
                          setValue('saleChannelDetailIpAddress', handleEnteringIp(value) ?? '')
                        }
                        labelMd={LABEL_INPUT}
                        colMd={3}
                        label="IPアドレス"
                        errorMessage={errors.saleChannelDetailIpAddress?.message}
                        hintText="miim-ECの場合はシステム保守チームから受取ったIPアドレスを登録してください。
                        外部サイトの場合はAPI接続先のIPアドレスを登録してください。"
                        hintTextClass="mt-1 w-460px"
                        register={{ ...register('saleChannelDetailIpAddress') }}
                      />

                      <Form.Group as={Row} className={`mb-3`}>
                        <Form.Label column md={3}>
                          <p>API認証情報</p>
                        </Form.Label>
                        <Col md={9} className="col-padding">
                          <Row className="mb-4px">
                            <Col md={3} className="p-0">
                              アクセストークン
                            </Col>
                            <Col md={9}>
                              <div
                                className="d-flex"
                                onClick={() => handleCopyClick(copyAccessKey)}
                                onKeyDown={() => handleCopyClick(copyAccessKey)}
                              >
                                <span className="mr-6px pointer">
                                  <CopyPasteIcon />
                                </span>
                                <div className="key-container">{accessKey}</div>
                              </div>
                            </Col>
                          </Row>
                          <Row>
                            <Col md={3} className="p-0">
                              シークレットトークン
                            </Col>
                            <Col md={9}>
                              <div
                                className="d-flex"
                                onClick={() => handleCopyClick(copySecretKey)}
                                onKeyDown={() => handleCopyClick(copySecretKey)}
                              >
                                <span className="mr-6px pointer">
                                  <CopyPasteIcon />
                                </span>
                                <div className="key-container">{secretKey}</div>
                              </div>
                            </Col>
                          </Row>
                        </Col>
                      </Form.Group>

                      {formTypeValue == 0 && (
                        <FormGroupInputEc
                          value={
                            watch('saleChannelDetailPlatformUsageFee')
                              ? watch('saleChannelDetailPlatformUsageFee')
                              : ''
                          }
                          onChange={(value) => {
                            setValue(
                              'saleChannelDetailPlatformUsageFee',
                              handleEnteringDecimal(value) ?? 0,
                            );
                          }}
                          labelMd={LABEL_INPUT}
                          colMd={2}
                          label="プラットフォーム利用料"
                          errorMessage={errors.saleChannelDetailPlatformUsageFee?.message}
                          messageWrapper="mt-8px ml-6px"
                          register={{ ...register('saleChannelDetailPlatformUsageFee') }}
                          hintText="%"
                          hintTextClass="ml-6px"
                          classInput="text-end"
                          classCol="d-flex align-items-center"
                        />
                      )}

                      <Form.Group as={Row}>
                        <Form.Label column md={3}>
                          <p>利用決済方法</p>
                        </Form.Label>
                        <Col md="3" className="col-padding">
                          <Form.Check
                            type="checkbox"
                            id={`payment-method-used`}
                            label="クレジットカード決済"
                            value={1}
                            className="custom-checkbox1"
                            checked={paymentMethodChecked}
                            onChange={() => handleCheckPaymentUsed()}
                          />
                        </Col>
                      </Form.Group>
                    </>
                  </BoxForm>
                </div>

                <div className="mt-4">
                  <BoxForm title="ECサイト売上振込口座">
                    <>
                      <FormGroupInput
                        value={watch('saleChannelDetailBankCode')}
                        onChange={(value) =>
                          setValue('saleChannelDetailBankCode', handleEnteringNumber(value) ?? '')
                        }
                        onBlur={(e: any) => {
                          if (watch('saleChannelDetailBankCode') == '') {
                            setValue('saleChannelDetailBankName', '');
                          }
                          getBankInfo2(e.target.value);
                          setValue('saleChannelDetailBranchCode', '');
                          setValue('saleChannelDetailBranchName', '');
                        }}
                        labelMd={LABEL_INPUT}
                        colMd={9}
                        label="銀行コード"
                        maxLength={4}
                        errorMessage={errors.saleChannelDetailBankCode?.message}
                        messageWrapper="mt-0 ml-6px"
                        register={{ ...register('saleChannelDetailBankCode') }}
                        classInput="w-60px"
                        classCol="d-flex align-items-center"
                        hintText={`銀行名 ${
                          watch('saleChannelDetailBankName') != undefined ? `:` : ''
                        }`}
                        hintTextClass="fs-12 ml-40px"
                        hintTextDes={`${
                          watch('saleChannelDetailBankName') != undefined
                            ? `${watch('saleChannelDetailBankName')}`
                            : ''
                        }`}
                        hintTextDesClass={`${
                          watch('saleChannelDetailBankName') == bankNameError
                            ? 'text-error ml-6px fs-small'
                            : 'ml-6px'
                        }`}
                      />

                      <FormGroupInput
                        value={watch('saleChannelDetailBranchCode')}
                        onChange={(value) =>
                          setValue('saleChannelDetailBranchCode', handleEnteringNumber(value) ?? '')
                        }
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        onBlur={(e: any) => {
                          if (watch('saleChannelDetailBranchCode') == '') {
                            setValue('saleChannelDetailBranchName', '');
                          }
                          if (watch('saleChannelDetailBranchCode') != '') {
                            getBankBranchInfo2(watch('saleChannelDetailBankCode'), e.target.value);
                          }
                        }}
                        labelMd={LABEL_INPUT}
                        colMd={9}
                        label="支店コード"
                        maxLength={3}
                        errorMessage={errors.saleChannelDetailBranchCode?.message}
                        messageWrapper="mt-0 ml-6px"
                        register={{ ...register('saleChannelDetailBranchCode') }}
                        classInput="w-60px"
                        disabled={
                          watch('saleChannelDetailBankName') == bankNameError ||
                          watch('saleChannelDetailBankName') == undefined ||
                          watch('saleChannelDetailBankName') == ''
                            ? true
                            : false
                        }
                        classCol="d-flex align-items-center"
                        hintText={`支店名 ${
                          watch('saleChannelDetailBranchName') != undefined ? `:` : ''
                        }`}
                        hintTextClass="fs-12 ml-40px"
                        hintTextDes={`${
                          watch('saleChannelDetailBranchName') != undefined
                            ? `${watch('saleChannelDetailBranchName')}`
                            : ''
                        }`}
                        hintTextDesClass={`${
                          watch('saleChannelDetailBranchName') == branchNameError
                            ? 'text-error ml-6px fs-small'
                            : 'ml-6px'
                        }`}
                      />

                      <CheckBoxs
                        id="account-ec-type"
                        name="account-ec-type"
                        labelMd={LABEL_INPUT}
                        colMd={COL_INPUT}
                        checkboxClass="flex-nowrap"
                        labelForm="口座種別"
                        value={watch('saleChannelDetailBankAccountType')}
                        options={AccountTypeEcOption}
                        onChange={({ value }) =>
                          setValue('saleChannelDetailBankAccountType', value)
                        }
                        classForm="mb-3"
                      />

                      <FormGroupInput
                        value={watch('saleChannelDetailBankAccountNumber')}
                        onChange={(value) =>
                          setValue(
                            'saleChannelDetailBankAccountNumber',
                            handleEnteringNumber(value) ?? '',
                          )
                        }
                        labelMd={LABEL_INPUT}
                        colMd={3}
                        label="口座番号"
                        errorMessage={errors.saleChannelDetailBankAccountNumber?.message}
                        register={{ ...register('saleChannelDetailBankAccountNumber') }}
                      />

                      <FormGroupInput
                        value={watch('saleChannelDetailBankAccountOwner')}
                        onChange={(value) =>
                          setValue('saleChannelDetailBankAccountOwner', value ?? '')
                        }
                        labelMd={LABEL_INPUT}
                        colMd={COL_INPUT}
                        label="口座名義（カタカナ）"
                        errorMessage={errors.saleChannelDetailBankAccountOwner?.message}
                        hintText="全角カタカナで入力してください（全角カタカナ、全角数字、全角スペース、記号（）．ー／）"
                        hintTextClass="mt-1"
                        register={{ ...register('saleChannelDetailBankAccountOwner') }}
                      />
                    </>
                  </BoxForm>
                </div>
              </>
            )}

            <div className="mt-4 detail-record-company-list" ref={scollToRef}>
              <BoxForm title="担当者情報">
                <>
                  {contactList.map((item: ContactInfomation, index) => {
                    return (
                      <Row className="mb-30px" key={index}>
                        <Col className="shadow border pt-2 pb-2">
                          <Row>
                            <Col md="6">
                              <div className="fw-bold d-block position-relative underline-100 pb-2 mb-2">
                                {`${item.accountName} ${
                                  item.sectionName ? `(${item.sectionName})` : ''
                                }`}
                              </div>
                              <div className="ps-3">
                                <div className="mb-2">{item.accountEmail}</div>
                                <NumberFormat
                                  value={item.accountPhone}
                                  format="###-####-####"
                                  className="border-0 pe-none"
                                />
                              </div>
                            </Col>
                            <Col md="4">
                              <>
                                {item.artistList.map((value, index) => {
                                  return (
                                    <p key={index} className="pb-1">
                                      {value}
                                    </p>
                                  );
                                })}
                              </>
                            </Col>
                            <Col md="2">
                              <div className="d-flex align-items-center h-100">
                                <Button
                                  onClick={() => handleLoginProxy(item.companyId, item.accountId)}
                                  className="w-100"
                                >
                                  代理ログイン
                                </Button>
                              </div>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    );
                  })}
                </>
              </BoxForm>
            </div>

            <div className="text-center mt-4">
              <div className="d-flex justify-content-end txt-require mt-2">
                ご注意：＊印は必須項目です。
              </div>
              <p className="mb-3 text-center">
                登録すると入力した担当者へログイン情報が記載されたメールが送信されます。
              </p>
              <Button type="submit" className="px-5 btn-equal-width" variant="primary">
                登録する
              </Button>
            </div>
          </Form>
        </Col>
      </Row>
    </Container>
  );
}
